// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4k-5";
export var imageContainer = "_4k-4";
export var metricsGrid = "_4k-2";
export var productDetailContainer = "_4k-1";
export var productListContainer = "_4k-0";
export var subscriberTableContainer = "_4k-3";